<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Đơn {{ data && data.type == 1 ? "mua" : "bán" }}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" v-if="isPopupActiveLocal">
				<!-- NAME -->
				<div class="mb-5" v-if="data2.status>=2">
					<label for class="text-base vs-input--label">
						{{data2.type == 2 ? 'Bên mua' : 'Bên bán'}}:
					</label>
					<label for class="text-base font-bold">
						{{data2.type == 2 ? getDataMatching('cus_name') : getDataMatching('supplier_name')}}
					</label>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Phụ phẩm:
					</label>
					<label for class="text-base font-bold">
						{{getProductName()}}
					</label>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Khối lượng:
					</label>
					<label for class="text-base font-bold">
						{{$helper.numFormat(quantity)}} (KG)
					</label>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Đơn giá:
					</label>
					<label for class="text-base font-bold">
						{{$helper.numFormat(price)}} (VND)
					</label>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Địa chỉ: </label>
					<label for class="text-base font-bold">
						{{address}}
					</label>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Ghi chú: </label>
					<label for class="text-base font-bold">
						{{note}}
					</label>
				</div>
				<!-- NAME -->
				<div class="mb-5" v-if="data.type == 2">
					<label for class="text-base vs-input--label"> Hình ảnh thực tế: </label>
					<div class="file-item" v-for="(file, index) in photos" :key="index">
						<img v-if="fileIsImage(file.extension)" class="responsive" :src="file.path" alt="" />
					</div>
					<span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
				</div>
			</div>
		</PerfectScrollbar>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";

export default {
	name: "CustomerForm",
	components: { vSelect, SelectAssigned, CbsUploadRef, ListUploadMode },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			data2: {},
			cus_name: null,
			supplier_name: null,
			status: 0,
			productName: null,
			timeKey: Date.now(),
			photos: [],
			files: [],
			value: {},
			product: null,
			quantity: null,
			price: null,
			address: null,
			note: null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			id: 0,
			product_id: 0,
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { type, product, quantity, price, address, photos = [], cus_note, id = 0 } = this.data;
			// console.log('this.data: ', this.data);
			if (product) {
				this.product = product.name;
				this.product_id = product.id;
			}
			if (quantity) {
				this.quantity = quantity;
			}
			if (price) {
				this.price = price;
			}
			if (address) {
				this.address = address;
			}
			if (photos) {
				this.photos = photos;
			}
			if (cus_note) {
				this.note = cus_note;
			}
			if (id) {
				this.id = id;
				this.getOrder();
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('set.value: ' , val);
				console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	methods: {
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getOrder() {
			console.log('getOrder');
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleProduct/getOrderById", this.id).then(response => {
					// this.sell = response;
					// if (response && response.photos) {
					// 	this.activePhoto = response.photos[0];
					// }
					this.data2 = response;
					console.log('getOrderById: ', response);

					const { supplier, product, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
						shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0, buy_id = 0, status = 0, cus_name
					} = this.data2;
					this.orderNow = orderNow;
					if (status) {
						this.status = status;
					} else {
						this.status = 0;
					}
					if (product) {
						this.product = product.id;
					} else {
						this.product = null;
					}
					if (supplier) {
						this.supplier = supplier.id;
					} else {
						this.supplier = null;
					}
					
					if (quantity) {
						this.quantity = quantity;
					} else {
						this.quantity = null;
					}
					if (shipping_options) {
						shippingOptions = shipping_options;
					}
					else {
						shippingOptions = {};
					}
					if (price) {
						this.price = price;
					} else {
						this.price = null;
					}
					if (cus_name) {
						this.cus_name = cus_name;
					} else {
						this.cus_name = null;
					}
					if (supplier_name) {
						this.supplier_name = supplier_name;
					} else {
						this.supplier_name = null;
					}
					if (supper_phone) {
						this.supper_phone = supper_phone;
					} else {
						this.supper_phone = null;
					}
					if (supper_mst) {
						this.supper_mst = supper_mst;
					} else {
						this.supper_mst = null;
					}
					if (supplier_bankaccount) {
						this.supplier_bankaccount = supplier_bankaccount;
					} else {
						this.supplier_bankaccount = null;
					}
					if (supplier_bankname) {
						this.supplier_bankname = supplier_bankname;
					} else {
						this.supplier_bankname = null;
					}
					if (supplier_bankowner) {
						this.supplier_bankowner = supplier_bankowner;
					} else {
						this.supplier_bankowner = null;
					}
					if (address) {
						this.address = address;
					} else {
						this.address = null;
					}
					if (cus_note) {
						this.cus_note = cus_note;
					} else {
						this.cus_note = null;
					}
					if (photos) {
						this.photos = photos;
					} else {
						this.photos = null;
					}
					if (id) {
						this.id = id;
					} else {
						this.id = null;
					}
					if (shipping_method) {
						this.shipping_method = shipping_method;
					}
					if (state_id) {
						this.province = state_id;
					} else {
						this.province = null;
					}
					if (district_id) {
						this.district = district_id;
					} else {
						this.district = null;
					}
					if (prevent_slit) {
						this.prevent_slit = 1;
					} else {
						this.prevent_slit = 0;
					}
					if (require_qc) {
						this.require_qc = 1;
					} else {
						this.require_qc = 0;
					}
					
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>
